//#region src/verticals/marketing/MarketingEvent.ts
var e = /* @__PURE__ */ function(e) {
	return e.PopupDisplayed = "marketing.popup.displayed", e.PopupDismissed = "marketing.popup.dismissed", e.BannerClicked = "marketing.banner.clicked", e.FeaturedListingClicked = "marketing.featured_listing.clicked", e.HomepageViewed = "marketing.page.homepage_viewed", e;
}({});
//#endregion
export { e as MarketingEvent };
